export default ({ assetsDirectory }) => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div>
  <!-- Description -->
  <p>{{PROVIDER_SUBTITLE_FILESYSTEM_ID}}</p>

  <!-- Button to open the good and bad example -->
  <div class="full-width bdr-a-application-primary q-pa-sm row items-center q-mt-md rounded-borders cursor-pointer" data-jcs-element="preview__page__open__info__id">
    <img class="preview-info-icon" src="${assetsDirectory}/images/info-icon.svg" />
    <span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
  </div>
  
  <!-- UI for good and bad examples -->
  <div class="preview-info-inner-container" data-jcs-element="preview__info__container__id">
    <div class="row justify-between items-center full-width">
      <p class="text-primary text-weight-medium">{{PREVIEW_INFO_TITLE_ID}}</p>
      <i class="cursor-pointer eva eva-close-circle-outline text-grey-8 text-h5" data-jcs-element="preview__page__close__info__id"></i>
    </div>
    <div>
      <div class="row q-gutter-x-sm q-pt-md q-mb-sm">
        <div class="col id-example-good">
          <img class="sample-image sample-image-success" src="${assetsDirectory}/images/licence-good.svg" />
          <div class="separating-rectangle q-mb-xs bg-positive"></div>
          <div class="text-positive row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/green-check-icon.svg" />
            <span>{{PREVIEW_INFO_GOOD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
        </div>
        <div class="col id-example-angle-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-angle.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
        </div>
      </div>
      <div class="row q-gutter-x-sm q-pt-md">
        <div class="col id-example-cover-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-covered.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
        </div>
        <div class="col id-example-blur-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-blurred.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section Header -->
  <p class="text-weight-bold q-mt-lg">
    <span data-jcs-element="info__journey__action" class="info-item__value">...</span>
  </p>
    
  <!-- Message for File type and size -->
  <div class="q-my-sm">
    <p class="text-grey-6 text-tab">{{FILESYSTEM_SUPPORTED_TYPES_START}}<i>{{FILESYSTEM_SUPPORTED_TYPES_END}}</i></p>
    <p class="text-grey-6 text-tab">{{FILESYSTEM_MAX_FILE_SIZE}}</p>
  </div>
    
  <!-- UI for dropping a file -->
  <div class="file-upload-container bdr-a-primary bdr-dashed bg-primary-pale rounded-borders-lg column items-center justify-center q-py-xl" data-jcs-element="file__drop__box">
    <form>
      <input data-jcs-element="file__input" class="file-input" id="jcs__file__input" type="file"/>
    </form>
    <div class="drag-and-drop-container">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M28.75 18.75C34.2733 18.75 38.75 23.2267 38.75 28.75C38.75 34.2733 34.2733 38.75 28.75 38.75C23.2267 38.75 18.75 34.2733 18.75 28.75C18.75 23.2267 23.2267 18.75 28.75 18.75Z"
            stroke="#7E878F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M28.75 33.75V23.75" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M28.75 23.75L25 27.5" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M28.75 23.75L32.5 27.5" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M6.25 11.25H23.75" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M6.25 18.75H16.25" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M6.25 26.25H12.5" stroke="#7E878F" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path
            d="M12.5 33.75H3.75C2.37 33.75 1.25 32.63 1.25 31.25V3.75C1.25 2.37 2.37 1.25 3.75 1.25H21.465C22.1283 1.25 22.7633 1.51333 23.2317 1.98167L28.0183 6.76833C28.4867 7.23667 28.75 7.87167 28.75 8.535V12.5"
            stroke="#7E878F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="color-gray">{{FILESYSTEM_DRAG_DROP}}</span>
      <span class="color-gray">{{FILESYSTEM_OR}}</span>
    </div>
    <button class="button bg-primary text-white text-weight-medium q-mt-md" onclick="document.getElementById('jcs__file__input').click()">
      {{FILESYSTEM_CHOOSE}}
    </button>
  </div>
    
  <!-- Messages for errors and uploading -->
  <div>
    <p class="check-error-color" data-jcs-element="file__too__large__error">{{FILESYSTEM_CHECK_FILE_TOO_BIG}}</p>
    <p class="check-error-color" data-jcs-element="invalid__format__error">{{FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT}}</p>
    <p data-jcs-element="uploading__file__without__preview">{{FILESYSTEM_UPLOADING}}</p>
  </div>
</div>
`
});
